import api from "./api";

export const getDashboardSummary = async () => {
  const { data } = await api.get("/admin/v1/dashboard/summary");
  return data;
};
